(function($) {

var mobileBreak = 1025;

$(document).ready(function(){
	// destination shower
	$('.megamenu--destinations .continent').on('mouseenter click',function(e){
		$(this).addClass('active').siblings().removeClass('active');
		var key = $(this).data('key');
		$(this).closest('.megamenu').find('.megamenu__section--2col').hide().eq(key).show();
	});
	// fix to make headers the same height on megamenus
	function sameHeight() {
		// console.log('running sameHeight');
		var menus = $('.megamenu');
		var sames = $('[same-height]');
		var maxHeight = 0;
		menus.each(function(){
			$(this).css({height:'auto'});
			var thisHeight = $(this).outerHeight();
			$(this).css({visibility:'hidden',display:'block',height:thisHeight});			
		});
		sames.each(function(){			
			$(this).css({
		        position:   'absolute',
		        visibility: 'hidden',
		        display:    'block'
		    });
		    var thisHeight = $(this).outerHeight();
		    if (thisHeight > maxHeight) {
		    	maxHeight = thisHeight;
		    }
		    $(this).attr('style','');
		});
		sames.css({height:maxHeight});
		menus.css({visibility:'visible',display:'none'});			
	}
	sameHeight();
	$(window).on('resize',sameHeight);
	// enable fixed header
	fixedHeader();	
	// show megamenu on hover
	var menuInterval;
	var menuDelay = 0;
	$('.topLink').hover(function(e) {
		var ref = $(this);
	    menuInterval = window.setInterval(function(){activateMegamenu(ref)}, 1);
	},function(e) {
	    window.clearInterval(menuInterval);
	    menuDelay = 0;
	    $(this).find('> .megamenu').stop().slideUp();
		$(this).removeClass('down');
	});
	$('.topLink').on('touchend',function(e){
		if (!$('.header__right__mobileTrigger:visible').length && ($(e.target).hasClass('topLink') || $(e.target).hasClass('has-mega') || $(e.target).closest('.has-mega').length)) {
			e.preventDefault();
			if ($(this).hasClass('down')) {
				$(this).removeClass('active');
			    $(this).find('> .megamenu').stop().slideUp();
				$(this).removeClass('down');	
			} else {
				$('.topLink.down').trigger('touchend');
				$(this).addClass('active');
				$(this).find('> .megamenu').stop().slideDown();
				$(this).addClass('down');
			}		
		}
	});
	function activateMegamenu(ref) {
		menuDelay++;
		if (!ref.hasClass('down') && menuDelay >= 100) {
			$('.header__switcher__current.open').trigger('click'); // close vertical switcher if open
			ref.addClass('down');
			ref.find('> .megamenu').stop().slideDown();		
		}
	}


	// show/hide menu for mobile
	$('.header__right__mobileTrigger').on('click',function(){
		if ($(this).hasClass('cross')) {
			$(this).removeClass('cross');
			$('.header__shade').fadeOut();
			$('.header__mobile').animate({right:-375},400);
		} else {
			$(this).addClass('cross');
			$('.header__shade').fadeIn();
			$('.header__mobile').animate({right:0},400);
		}
	});

	// hide menu on fade click
	$('.header__shade').on('click',function(){		
		$(this).fadeOut();
		$('.header__right__mobileTrigger').removeClass('cross');
		$('.header__mobile').animate({right:-375},400);
	});

	// open mobile dropdown
	$('.header__mobile__nav .dropdown').on('click',function(){
		var topLink = $(this).closest('.topLink');
		topLink.toggleClass('open');
		topLink.find('.topLink__more').slideToggle();
	});
});

$(window).on('resize scroll',fixedHeader);

var placeSpot = 0;
var rotate;
function fixedHeader() {
	if ($('body').prop('clientWidth') >= mobileBreak) {
		var winTop 	= $(window).scrollTop();
		var $header = $('.header');	
		if (winTop > 0) {
			if (!$header.hasClass('scrolled') && !$('.megamenu:visible').length && !$('.header__top__search .results:visible').length) {
				$header.addClass('scrolled');
			}
		} else {
			$header.removeClass('scrolled');
		}
	}
}

})( jQuery );
